import { useSelector } from 'react-redux'

import { getAuthUserId } from '../../../../data/auth/authSelectors'
import { RTKQueryHook, RTKQueryResultType } from '../../../../data/baseApi'
import { useGetDraftsQuery } from '../messagesApi'

export const useDraftsData: RTKQueryHook<typeof useGetDraftsQuery> = (args, opts) => {
  const userId = useSelector(getAuthUserId)
  return useGetDraftsQuery(
    {
      providerId: userId,
      ...args,
    },
    opts,
  ) as RTKQueryResultType<typeof useGetDraftsQuery>
}
